import * as React from 'react'

/**
 * Paginator that shows previous/next buttons, as well as a series of buttons with specific page numbers.
 * These buttons are prefixed/suffixed appropriately with "..." when there are more props.padding pages to
 * either side of the current page.
 *
 * The component is given the following CSS classes:
 *  * .paginator for the outer div
 *  * .page-button for the specific page buttons, and also for the "..."
 *  * .enabled / .disabled depending on whether the button can be pressed (e.g. can't press the "left" button when already on page 1).
 *  * .active for the current .page-button
 *  * .filler for the "..."
 */
export class Paginator extends React.Component<PaginatorProps, {}> {

	private static DEFAULT_PADDING = 3;

	private getPadding() {
		return typeof this.props.padding !== 'undefined' && this.props.padding != null ? this.props.padding : Paginator.DEFAULT_PADDING;
	}

	render() {
		return <div className="paginator">
			{this.createButton(this.props.currentPage - 1, "Previous", this.props.currentPage > 0)}
			{this.leftFiller()}
			{this.centreButtons()}
			{this.rightFiller()}
			{this.createButton(this.props.currentPage + 1, "Next", this.props.currentPage < this.props.numPages - 1)}
		</div>
	}

	private centreButtons() {
		const min = Math.max(0, this.props.currentPage - this.getPadding());
		const max = Math.min(this.props.numPages, this.props.currentPage + this.getPadding());
		const buttons:JSX.Element[] = [];
		for (var i = min; i < max; i ++) {
			buttons.push(this.createButton(i, (i + 1).toString(), true));
		}
		return buttons;
	}

	private leftFiller() {
		return (this.props.currentPage - this.getPadding() > 0) ? this.createFiller() : null;
	}

	private rightFiller() {
		return (this.props.currentPage + this.getPadding() < this.props.numPages - 1) ? this.createFiller() : null;
	}

	private createButton(page:number, label:string, isEnabled:boolean) {
		const onClick = (event:React.SyntheticEvent<{}>) => {
			if (isEnabled) {
				this.props.onSelectPage(page)
			}
			event.preventDefault()
		};

		const enabledClass = isEnabled ? 'enabled' : 'disabled'
		const activeClass  = this.props.currentPage == page ? 'current' : ''
		const className    = `page-button ${enabledClass} ${activeClass}`
		const key          = `button-${page}`

		return (this.props.currentPage == page || !isEnabled)
			? <span key={key} className={className}>{label}</span>
			: <a key={key} href="#" onClick={onClick} className={className}>{label}</a>
	}

	private createFiller() {
		return <span className="page-button filler">...</span>
	}

}

export interface PaginatorProps {
	currentPage:number;
	numPages:number;
	onSelectPage:(selectedPage:number) => void;
	padding?:number
}



// WEBPACK FOOTER //
// ./src/react-components/Paginator.tsx